export const WORKER_POOL_SHARED_VALUE = "none-use-shared";
export const WORKER_POOL_SHARED_LABEL = "Use the public worker pool";
